import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { TranslateService } from '@ngx-translate/core';



@Injectable()
export class AirportVectorService extends BaseService<any>{
    constructor(public httpClient: HttpClient, public translation: TranslateService) {
        super(
            'airportVector',
            httpClient);
    }

    autocomplete = this.searchPortVector;

searchPortVector(q): Observable<any[]> {
    let uri = new URL(environment.baseUrl + `/airports/search`).updateQueryParam({q});

    return this.httpClient.get<any[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
        .pipe(
            map((res: any[]) => {
                
                return res.map(item => ({
                    ...item,
                    id: item.airportId,       
                    name: this.translation.currentLang == 'en' ? item.displayNameEn : item.displayNameTr
                }));
            }),
            catchError(this.handleError)
        )
}


}
